import { WebinarExperienceType } from '../../../../Utils/Constants';

export function getWebinarType(experienceType) {
  switch (experienceType) {
    case 'classic':
      return WebinarExperienceType.CLASSIC;
    case 'broadcast':
      return WebinarExperienceType.WEBCAST;
    case 'simulive':
      return WebinarExperienceType.SIMULIVE;
    default:
      return;
  }
}



// WEBPACK FOOTER //
// ./src/GoToWebinar/Sessions/SessionDetails/Utils/SessionDetailsUtil.js